import { RangeValues } from '@interfaces/components/range-slide.interface';
import { useState } from 'react';
import { Range } from 'react-range';

interface Props {
  step: number;
  min: number;
  max: number;
  onChange: ({ start, end }: RangeValues) => void;
  defaultRangeValues: RangeValues | undefined;
}

const RangeSlide = ({
  step,
  min,
  max,
  onChange,
  defaultRangeValues,
}: Props) => {
  min = min >= max ? min - 1 : min;

  const [displayRangeValues, setDisplayRangeValues] = useState<RangeValues>({
    start: defaultRangeValues?.start ?? min,
    end: defaultRangeValues?.end ?? max,
  });

  return (
    <>
      <Range
        step={step}
        min={min}
        max={max}
        values={[displayRangeValues.start, displayRangeValues.end]}
        onChange={(values) => {
          setDisplayRangeValues({ start: values[0], end: values[1] });
        }}
        onFinalChange={(values) => {
          onChange({ start: values[0], end: values[1] });
        }}
        renderTrack={({ props, children }) => (
          <div {...props} className="range-track">
            {children}
          </div>
        )}
        renderThumb={({ props }) => <div {...props} className="range-thumb" />}
      />
    </>
  );
};

export default RangeSlide;
